import { DaliServiceBase, WsDali } from "./wsdl/WsDali/v1.07/WsDali.ts";

export {
    type WsDali
};

export class DaliService extends DaliServiceBase {
}
